module.exports = __webpack_public_path__ + "img/itinerary_details_icon.64e159f1.png";